// Manage.js
import React from 'react';
import { useState, useEffect } from 'react'
import { Table, Button, Tag, Badge, Radio, Popconfirm, Avatar } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { getAllApps, deleteApp } from "../../services/client";
import { successNotification, errorNotification } from '../../utils/Notification';
import EditAppDrawerForm from '../../components/DrawerForm/EditAppDrawerForm/EditAppDrawerForm';
import AppDrawerForm from '../../components/DrawerForm/AppDrawerForm/AppDrawerForm';
import LoadingEmptyComponent from '../../components/LoadingEmptyComponent/LoadingEmptyComponent';
import './Manage.css';

const removeApp = (appName, appId, callback) => {
    deleteApp(appId).then(() => {
        successNotification("App deleted", `${appName} with appID ${appId} was deleted`);
        callback();

    }).catch(err => {
        err.response.json().then(res => {
            console.log(res);
            errorNotification(
                "There was an issue",
                `${res.message} [${res.status}] [${res.error}]`
            )
        });
    })
}

const openURL = (url) => {
    window.open(url) || window.location.assign(URL);
}

const columns = (fetchApps, showEditDrawer, closeEditDrawer, setShowEditDrawer, selectedApp, EditAppDrawerForm, setSelectedApp) => [
    {
        title: 'Id',
        dataIndex: 'appId',
        key: 'appId',
        width: 150,
        fixed: 'left',
    },
    {
        title: 'Logo',
        key: 'logo',
        width: 150,
        render: (text, app) => {
            return <Avatar src={app.logo} />
        },
        fixed: 'left',
    },
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        width: 150,
        fixed: 'left',
    },
    {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
        width: 200,
    },
    {
        title: 'Container Port',
        dataIndex: 'containerPort',
        key: 'containerPort',
        width: 100,
    },
    {
        title: 'Docker Port',
        dataIndex: 'dockerPort',
        key: 'dockerPort',
        width: 100,
    },
    {
        title: 'Website',
        dataIndex: 'website',
        key: 'website',
        width: 150,
    },
    {
        title: 'Host Platfrom',
        dataIndex: 'hostPlatform',
        key: 'hostPlatform',
        width: 100,
    },
    {
        title: 'Actions',
        key: 'actions',
        width: 200,
        render: (text, app) =>
            <>
                <Radio.Group>
                    <Radio.Button onClick={() => openURL(app.website)} value="small">Launch</Radio.Button>
                    <Radio.Button onClick={() => openURL(app.githubRepo)} value="small">Github</Radio.Button>
                </Radio.Group>
                <Radio.Group>
                    <Popconfirm
                        placement='topRight'
                        title={`Are you sure to delete ${app.name}`}
                        onConfirm={() => removeApp(app.name, app.appId, fetchApps)}
                        okText='Yes'
                        cancelText='No'>
                        <Radio.Button value="small">Delete</Radio.Button>
                    </Popconfirm>
                    <Radio.Button onClick={() => { setSelectedApp(app); setShowEditDrawer(!showEditDrawer); }} value="small">Edit</Radio.Button>
                </Radio.Group>
            </>

    }
];

const RenderApps = () => {
    const [showDrawer, setShowDrawer] = useState(false);
    const [showEditDrawer, setShowEditDrawer] = useState(false);
    const [selectedApp, setSelectedApp] = useState([]);
    const [fetching, setFetching] = useState([]);
    const [apps, setApps] = useState([]);

    const fetchApps = () => {
        getAllApps()
            .then(res => res.json())
            .then(data => {
                console.log(data);
                setApps(data);
            }).catch(err => {
                console.log(err.response)
                err.response.json().then(res => {
                    console.log(res);
                    errorNotification(
                        "There was an issue",
                        `${res.message} [${res.status}] [${res.error}]`
                    )
                });
            }).finally(() => setFetching(false))
    };

    useEffect(() => {
        console.log("component is mounted");
        fetchApps();
    }, []);

    const closeEditDrawer = () => {
        setShowEditDrawer(false);
        console.log(selectedApp)
        setSelectedApp([]); // Reset the selectedApp when the form is closed

    };

    return (
        <>
            <AppDrawerForm
                showDrawer={showDrawer}
                setShowDrawer={setShowDrawer}
                closeEditDrawer={closeEditDrawer}
                fetchApps={fetchApps} />
            <EditAppDrawerForm
                showEditDrawer={showEditDrawer}
                closeEditDrawer={closeEditDrawer}
                fetchApps={fetchApps}
                app={selectedApp} />
            <Table
                dataSource={apps}
                columns={columns(fetchApps, showEditDrawer, closeEditDrawer, setShowEditDrawer, EditAppDrawerForm, selectedApp, setSelectedApp)}
                title={() => (
                    <>
                        <Tag>Number of apps:</Tag>
                        <Badge count={apps.length} className="site-badge-count-4" />
                        <br /><br />
                        <Button onClick={() => setShowDrawer(!showDrawer)} type="primary" icon={<PlusOutlined />} size="medium">
                            Add New App
                        </Button>
                    </>
                )}
                pagination={{ pageSize: 50 }}
                scroll={{ y: 1000 }}
                rowKey={(app) => app.appID}
            />
            <LoadingEmptyComponent loading={fetching} data={apps} />
        </>
    );
};

export default RenderApps;
